import {
	browserTracingIntegration,
	init,
	replayIntegration,
} from "@sentry/remix";
/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import { StrictMode, startTransition, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";

declare global {
	interface Window {
		ENV?: {
			USE_SENTRY?: boolean;
			SENTRY_DSN?: string;
			ENVIRONMENT?: string;
		};
	}
}

if (window?.ENV?.USE_SENTRY) {
	init({
		dsn: window?.ENV?.SENTRY_DSN,
		tracesSampleRate: 1,
		enableLogs: true,
		environment: window?.ENV?.ENVIRONMENT ?? "LOCAL",

		integrations: [
			browserTracingIntegration({
				useEffect,
				useLocation,
				useMatches,
			}),
			replayIntegration({
				maskAllText: true,
				blockAllMedia: true,
			}),
		],

		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1,
		sendDefaultPii: true,
	});
}

startTransition(() => {
	hydrateRoot(
		document,
		<StrictMode>
			<RemixBrowser />
		</StrictMode>,
	);
});
